var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title"},[_c('ul',{staticClass:"title-book-list"},_vm._l((_vm.menus),function(menu,index){return _c('li',{key:index},[_c('router-link',{staticClass:"default-a",attrs:{"to":menu.path,"exact":""}},[_vm._v(_vm._s(menu.name))])],1)}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65e1d428","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/HeadL.vue
// module id = null
// module chunks = 